// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"New_wrapper__GnBQw","grayDiv":"New_grayDiv__3kQUZ","text":"New_text__3j2_f","image":"New_image__2wdyk","imageHome":"New_imageHome__1dl91"};